import { AuthService } from './auth.service';

export function AUTH_INITIALIZER_FACTORY(authService: AuthService) {
  return (): void => authService.init();
}
